import React, { useState } from "react";

export default function RequestReportButton({ RestaurantID }) {
  const [showModal, setShowModal] = useState(false);
  const [periodFrom, setPeriodFrom] = useState("");
  const [periodTo, setPeriodTo] = useState("");
  const [email, setEmail] = useState(""); // comma-separated emails

  const [reportSubmitting, setReportSubmitting] = useState(false);
  const [reportError, setReportError] = useState(null);        // short msg
  const [reportDebug, setReportDebug] = useState(null);        // detailed info

  const REDIR_BASE = "https://mydata.tablemate.net/redir.php?url=";
  const REQUEST_REPORT_API_URL =
    "https://app.tablemate.net/endpoints/reports/request_report.php";

  const handleOpen = () => setShowModal(true);
  const handleClose = () => {
    if (!reportSubmitting) {
      setShowModal(false);
      setReportError(null);
      setReportDebug(null);
    }
  };

  const handleReportSubmit = async (e) => {
    e.preventDefault();
    setReportSubmitting(true);
    setReportError(null);
    setReportDebug(null);

    const payload = {
      action: "request_Executive_report",
      restaurant_id: RestaurantID,
      period_from: periodFrom,
      period_to: periodTo,
      email,
    };

    try {
      const url = REDIR_BASE + encodeURIComponent(REQUEST_REPORT_API_URL);
      console.log("[Report] POST", url, payload);

      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const status = response.status;
      const statusText = response.statusText;

      const rawText = await response.text(); // read once
      let data = null;
      try {
        data = JSON.parse(rawText);
      } catch {
        // non-JSON error page, keep rawText
      }

      console.log("[Report] Response status:", status, statusText);
      console.log("[Report] Raw response text:", rawText);
      console.log("[Report] Parsed JSON:", data);

      const backendMessage =
        data && (data.message || data.error || data.error_message);

      if (!response.ok || (data && data.success === false)) {
        const shortMessage =
          backendMessage ||
          `Server error (${status}${statusText ? " " + statusText : ""})`;

        setReportError(shortMessage);
        setReportDebug(
          JSON.stringify(
            {
              status,
              statusText,
              backend: data,
              rawText,
            },
            null,
            2
          )
        );

        throw new Error(shortMessage);
      }

      // Success
      console.log("[Report] Report request submitted OK:", data);
      setShowModal(false);
      // optional: reset form
      // setPeriodFrom("");
      // setPeriodTo("");
      // setEmail("");
    } catch (err) {
      console.error("[Report] Failed to submit report request:", err);
      if (!reportError) {
        setReportError(err.message || "Failed to submit report request.");
      }
    } finally {
      setReportSubmitting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="tm-request-report-btn"
        onClick={handleOpen}
      >
        Request Executive Report
      </button>

      {showModal && (
        <div className="tm-modal-backdrop" onClick={handleClose}>
          <div
            className="tm-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="tm-modal-header">
              <h2>Request Executive Report</h2>
              <button
                type="button"
                className="tm-modal-close"
                onClick={handleClose}
              >
                ×
              </button>
            </div>

            <div className="tm-modal-info">
              <p>This report will be generated by Table Mate and include:</p>
              <ul>
                <li>
                  Summary of key KPIs (sales, orders, tables, usage and customer
                  ratings)
                </li>
                <li>Top-performing items and time-of-day analysis</li>
                <li>Trend charts for the selected period</li>
                <li>Actionable recommendations based on YOUR data!</li>
              </ul>
              <p className="tm-modal-price">
                Price:{" "}
                <strong>
                  <u>BWP 1499.95</u> per report
                </strong>
              </p>
            </div>

            <form className="tm-modal-form" onSubmit={handleReportSubmit}>
              <div className="tm-form-field tm-form-field-row">
                <div>
                  <label>
                    Data period – From
                    <input
                      type="date"
                      value={periodFrom}
                      onChange={(e) => setPeriodFrom(e.target.value)}
                      required
                    />
                  </label>
                </div>
                <div>
                  <label>
                    Data period – To
                    <input
                      type="date"
                      value={periodTo}
                      onChange={(e) => setPeriodTo(e.target.value)}
                      required
                    />
                  </label>
                </div>
              </div>

              <label className="tm-form-field">
                Emails to receive the report (separate by comma)
                <textarea
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com, manager@example.com"
                  required
                />
              </label>

              {reportError && (
                <div className="tm-modal-error">
                  <strong>Error:</strong> {reportError}
                  {reportDebug && (
                    <details style={{ marginTop: 6 }}>
                      <summary>Show technical details</summary>
                      <pre style={{ whiteSpace: "pre-wrap", fontSize: 11 }}>
                        {reportDebug}
                      </pre>
                    </details>
                  )}
                </div>
              )}

              <div className="tm-modal-actions">
                <button
                  type="button"
                  className="tm-btn-secondary"
                  onClick={handleClose}
                  disabled={reportSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="tm-btn-primary"
                  disabled={reportSubmitting}
                >
                  {reportSubmitting ? "Submitting..." : "Submit Request"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
